"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.omit = exports.memoized = exports.deepFlatten = void 0;
// recursively flatten an array
function deepFlatten(arr) {
    return (Array.isArray(arr))
        ? arr.flatMap(deepFlatten)
        : arr;
}
exports.deepFlatten = deepFlatten;
// Lazily returns a value, returning a cached version on subsequent calls
function memoized(callback) {
    let cached = null;
    return () => {
        if (cached)
            return cached;
        cached = callback();
        return cached;
    };
}
exports.memoized = memoized;
function omit(obj, props) {
    const draft = { ...obj };
    for (const prop of props)
        delete draft[prop];
    return draft;
}
exports.omit = omit;
